<template>
    <div class="animated fadeIn delay-0.5s">

    <!-- <div id="Loading">
        <div class="loader-inner ball-beat">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div> -->

  <div class = 'container'>
     <div class="content-container-large">
            <img src="https://miro.medium.com/max/1400/1*bU-LAlKf_UtVjtL5wShiTg.png" width='100%' class='large-img'>
            
    </div>
    <div class="first-page">
        <div class="content-container-title">
            <div class="parent">
                <div class = "left">
                    <div class="paragraph">
                        <!-- <h1>A-Watch</br>Child Asthma Management Toolkit</h1> -->
                        <h1>ShelfClock</h1>
                        <h6>Time, at your glance.</h6>
                        <p>
                        ShelfClock is a concept design for Nest, the Google Home brand, that:<br>
                        Connects to your home: Washing machine, smart light, thermostat, and more;<br>
                        Talks to your app: Phone, Calendar, Clock, Canvas, Mail.<br>
                        </p>
                    </div>
                    <div class="info">
                        <div class = "left-left">
                        <h3>TIMELINE</h3>
                        <h3>TOPIC</h3>
                        <h3>TEAM</h3>
                        </div>
                        <div class= "left-right">
                            <p>Jul 2019, 1 week</p>
                            <p>Smart Home, Concept Design</p>  
                            <p>Sixuan Li, Evie Zhang, Feng Wang, Chenyu Cui </p>
                            </div>
                    </div>
                </div>
                <div class = "right">
                    <div class="paragraph">
                        <h2>My role</h2>
                            <p>
                                Product Designer
                            </p>
                        <h2>Skills</h2>
                            <p>
                                3D Modeling<br>
                                Rendering<br>
                                Interaction Design<br>
                            </p>
                        <h2>Toos</h2>
                            <p> 
                                Figma<br>
                                Rhinoceros<br>
                                KeyShot
                            </p>     
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="light-page">
        <div class="content-container">
            <div class="title">
                <div class = "title-color2"> </div>
                <div class="title-text">
                    <h4>Concept & Inspirations</h4>
                    <h5>&nbsp</h5>
                </div>
            </div>
            <div class="paragraph">
                <blockquote>"Your app and your home, in minutes and seconds."</blockquote>
                <h4>Time at a glance</h4>
                <p>
                    In our childhood memory, the wall clock represents authority and reminds the elapse of time. Also, it saves us from the screens.
                </p>
            </div>
            <div class="paragraph">
                <h4>Time into the background</h4>
                <p>
                The decorative design makes it blends in your living room. To keep time, you don’t need a phone; nor do you need an alarm clock.
                </p>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*WEEv8A64-LAUXhVB2oPJfA.png" width="100%">
                </div>
            </div>
            <div class="paragraph">
                <h4>Time with more facets</h4>
                <p>
                it is everywhere in your physical home and digital life
                </p>
                <div class='image-middle-container'>
                    <img src="https://miro.medium.com/max/1400/1*3Fq4lgakkecrSer1vlXKHg.png" width="100%">
                </div>
            </div>
        </div>
    </div>
    <div class="light-page">
        <div class="content-container">
            <div class="title">
                <div class = "title-color2"> </div>
                <div class="title-text">
                    <h4>Target Audience</h4>
                    <h5>&nbsp</h5>
                </div>
            </div>
            <div class="paragraph">
                <h4>Smart-home pioneers</h4>
                     <div class="quote">
                        <p>
                        133M smart speakers in the U.S.
                        </p>
                    </div>
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*JM-9ZDvySpVUlYZqCMKRfg.png" width="100%">
                </div>
                <p>
                Home assistant and smart home devices are experiencing rapid growth & focused mainly on smart sensors. This product expands its territory to the “daily necessity” category.    
                </p>
            </div>
            <div class="paragraph">
                <h4>Living a Google life</h4>
                     <div class="quote">
                        <p>
                        1B devices running Google Assistant by Jan 2019
                        </p>
                    </div>
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*CPI6ISNbecGXH4Tzb9CsoQ.png" width="100%">
                </div>
                <p>
                Targeting mainly Android users, and more broadly, Google users.
                </p>
            </div>
            <div class="paragraph">
                <h4>Phone Escapers</h4>
                     <div class="quote">
                        <p>
                        Hoping for a distraction-free life
                        </p>
                    </div>
                <p>
                Phones are a source of distraction. So are screens (that have a touch display). This product connects your digital life in the simplest way — digital tubes.
                </p>
            </div>
         </div>
    </div>
    <div class="light-page">
        <div class="content-container">
            <div class="title">
                <div class = "title-color2"> </div>
                <div class="title-text">
                    <h4>Scenarios</h4>
                    <h5>&nbsp</h5>
                </div>
            </div>
            <div class="paragraph">
                <h4>Flow with Google</h4>
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*-nKj8vHLDxGWEqaX_LfK4w.png" width="100%">
                    <figcaption>Check Status(left), On the Call(middle), Set Reading Time(right)</figcaption>
                </div>
            </div>
            <div class="paragraph">
                <h4>Flow with Your Apps</h4>
                <p>
                    Example: a commandless Canvas software
                </p>
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*XScvcgYHzomJUQwIrH8eBQ.png" width="100%">
                    <figcaption>Prompt(left), Alert(middle), Dismissal(right)</figcaption>
                </div>
            </div>
            <div class="paragraph">
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*e7kI0qOw6FEfOu4GVTQWyg.png" width="100%">
                </div>
            </div>
        </div>
    </div>
    <div class="light-page">
        <div class="content-container">
            <div class="title">
                <div class = "title-color2"> </div>
                <div class="title-text">
                    <h4>Branding</h4>
                    <h5>&nbsp</h5>
                </div>
            </div>
            <div class="paragraph">
                <h4>Icon in Google Home app</h4>
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*u072AwGRVYMFKPWDcoImzQ.png" width="100%">
                </div>
            </div>
            <div class="paragraph">
                <h4>Typography</h4>
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*7JBKKcDyILuerwFHYOOhgQ.png" width="100%">
                </div>
            </div>
            <div class="paragraph">
                <h4>Packaging</h4>
                <div class='image-middle-container text-image' style='width:100%'>
                    <img src="https://miro.medium.com/max/1400/1*Nr3M1wVgFTRzQhnOFg0nnA.png" width="100%">
                </div>
            </div>
        </div>
    </div>    

    <div class="light-page">
        <div class="content-container">
            <div class="ending-pointer">
                <div onclick="window.location.href='/#/clubhusky'">
                    <span class="next">Next Project</span><br/>
                    <span class="project">clubHusky</span>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</template>


<script>
export default {
        created() {  
        var delayInMilliseconds = 800;
        setTimeout(function() {
            document.body.removeChild(document.getElementById('Loading'))   
        }, delayInMilliseconds); 
    },
}
</script>

<style>
.title{
    margin-top: 20px;
    margin-bottom: 0px;
    padding-left: 0px;
    vertical-align: left;
    display:flex;
}



p{
    font-family: 'Source Sans Pro', sans-serif;
    margin:0;
    line-height: 29px;
    font-size: 16px;
    letter-spacing: 0.05em;
    font-weight: 500;
    color: #000000;
    text-align:left;
    /* margin-bottom:5rem; */
}
h1{
    font-weight: bold;
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 30px;
    line-height: 2.4rem;
    color: #000000;
    margin: 10px 0 0 0;
    text-align:left;
}
h2{
    font-weight: bold;
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 20px;
    color: #000000;
    margin: 18px 0 11px 0;
    text-align:left;
}
h3{
    font-weight: bold;
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 18px;
    color: #000000;
    line-height: 29px;
    text-align:left;
    /* text-transform: uppercase; */
    margin:0;
}
h4{
    font-weight:bolder;
    /* font-weight:1000; */
    letter-spacing:0.1em;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 24px;
    color:#000000;
    text-align:left;
    margin-top:0rem;
    margin-bottom:1rem;

}

h6{
    font-weight: bold;
    letter-spacing:1px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 22px;
    color: #9d9d9d;
    margin: 12px 0 20px 0;
    text-align:left;

}
.paragraph{
    margin-top:2rem;
    margin-bottom:2rem;
}

p.video{
    margin: 30px 0 80px;
    text-align: center;
}
.quote{
    position: relative;
    border-left: dashed #a4a4a4 1px;
    margin: 20px;
    margin-right: 0;
    margin-left: 25px;
    padding-left: 8px;
    /* margin-bottom:20px; */
    /* font-style: italic; */
}

.quote>p>b.yellow{
    color: #F3D884;
}
.quote>p>b.orange{
    color: #F2994A;
}
.interview{
    display: flex;
    margin-top:4rem;
}
.interview2{
    display: flex;
}
.right_p{
    flex:1;
    margin-left: 3rem;
    }
.right_p2{
    flex:1;
    }
.left_p2{
    flex: 0 0 7rem;
}
.left_p{
    flex: 0 0 300px;
}
img{
    /* margin: 0px 0 5px 0; */
}
.image-middle-container{
    margin: 40px auto;
}
.large-img{
    margin:3rem 0 3rem 0;
}
.table-3>tbody>tr>td{
    padding: 20px 30px;
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 29px;
    font-size: 15px;
    letter-spacing: 0.04em;
    border: 0;
    vertical-align: top;
}

.table-3>tbody>tr>td>h3{
    margin: 0;
}

.table-3-left{
    width: 35%;
}
.table>tbody>tr>td, .table>tbody>tr>th{
    border: solid #ffffff 2px;
    padding: 10px;
    vertical-align: middle;
    font-family: 'Source Sans Pro', sans-serif;
    line-height: 27px;
    font-size: 15px;
    letter-spacing: 0.04em;
}

.table>tbody>tr>td{
    text-align: left;
}

.table>tbody>tr>th{
    text-align: center;
}

h3.black{
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;
    font-weight: bold;
    line-height: 29px;
    font-size: 15px;
    letter-spacing: 0.04em;
    color: #000000;
}

h3.gray{
    font-family: 'Source Sans Pro', sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 29px;
    font-size: 15px;
    letter-spacing: 0.04em;

    color: #000000;
}

td.dark-td{
    background-color: #f2f2f2; ;
    padding:15px 20px;
}

td.light-td{
    background-color: #ffffff; ;
    padding:15px 20px;
}
.dark-dark-page{
    position: relative;
    background-color: #E0E0E0;
    padding: 20px 20px 60px;
}
.text-image{
    width:86%;
    margin:40px auto;
}
.findings{
    margin:20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/shelfclock.vue